// import logo from './logo.svg';
import './App.css';
import ParenthesisCounter from "./components/parenthesis_counter"

function App() {
  return (
    <div className="flex justify-center items-center min-h-screen bg-gray-100">
    <div className="w-full max-w-lg bg-blue p-6 rounded shadow">
      <h1 className="text-2xl font-bold mb-4 text-center">Template Blast</h1>
      <ParenthesisCounter />
    </div>
  </div>
  );
}

export default App;
